import React from "react";
import { connect } from "react-redux";
import WeekTable from "./weektable/index.jsx";
import { SetTerm } from "./store";
import moment from "moment";


export function TermGroup(props) {
    
    let weeks = props.days.reduce((blocks, date) => {
        let d = new Date(date);
        let key = `${d.format("o")}${(d.format("W") < 10 ? "0" : "")}${d.format("W")}`;
        if (!blocks[key]) {
            blocks[key] = [];
        }
        blocks[key].push(date);
        return blocks;
    }, {})
    let discountMessage = null;
    if(props.discount){
        let cutoffMessage = null;
        if(props.discount.cutoff){
            cutoffMessage = ` - Offer ends ${moment(props.discount.cutoff).format("Do MMMM")}`
        }
        if(props.discount.type == "early"){
            if(cutoffMessage == null) {
                discountMessage = <span className="discount-message"><strong>{props.discount.discount}% OFF</strong> Book Now!</span>
            } else {
                discountMessage = <span className="discount-message"><strong>{props.discount.discount}% OFF</strong> Early Bird{cutoffMessage}</span>
            }
        }else if(props.discount.type == "consecutive"){
            discountMessage = <span className="discount-message"><strong>{props.discount.discount}% OFF</strong> Full Week Booking{cutoffMessage}</span>
        }else if(props.discount.type == "sibling"){
            discountMessage = <span className="discount-message"><strong>{props.discount.discount}% OFF</strong> Sibling Discount</span>
        }
    }
    return <div>
        <div className="input-group term-selector">
            <input type="checkbox" name="course-options" id={`choose-days-${props.idx}`} value="choose-days" checked={props.isOpen} onChange={()=> props.open()} />
            <label htmlFor={`choose-days-${props.idx}`} >
                {props.label}
                <span>{new Date(props.from).format("l j F")} - {new Date(props.to).format("l j F")}</span>
                {discountMessage}
            </label>
        </div>
        <div className="day-selector" style={{ display: props.isOpen ? "":"none" }}>
            <table className={`table-no-wrap ${props.isMobile ? "mobile" : ""}`}>
                {Object.keys(weeks).map(k => weeks[k]).map((block, idx) => (
                    <WeekTable
                        key={idx}
                        isMobile={props.isMobile}
                        dates={block}
                        weekNo={(new Date(block[0]).format("W") - new Date(props.from).format("W")) + 1}
                    />
                ))}
            </table>
        </div>
    </div>
}
export default connect((state, ownProps) => ({
    isOpen: !!state.term[ownProps.idx],
    isMobile: state.isMobile
}), (dispatch, ownProps) => ({
    open: () => dispatch(SetTerm(ownProps.idx, ownProps.days))
}) )(TermGroup)


// WEBPACK FOOTER //
// ./flexi/TermGroup.jsx